import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {LoginComponent} from "../login/login.component";
import {User} from "../../models/user";
import {environment} from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovimientosComponent } from 'src/app/modales/movimientos/movimientos.component';

declare var $: any;

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: [
    './servicios.component.css',
    '../login/font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers: [UserService]
})
export class ServiciosComponent implements OnInit {
  public identity;
  public token;
  public serviciosAsociado;
  public servicios;
  public serviciosactivos;
  public mvtoservicios;
  paginaactual: number = 1;
  public user: User;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public serviciosConfig
  public mobile

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }

  ngOnInit() {
    this.spinner.show()
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.serviciosConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    this.token = this._userService.GetsessionStorage('token');
    this.consultarServicios();
    this.consultarServiciosActivos()

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  decodeBuffer(arraybuffer?) {
    if (arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  consultarServicios() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year +'-'+ (monthIndex+1) +'-'+ day
    };
    this._userService.httpPost('servicios', data).subscribe(
      response => {
       // console.log(response)
        if (response.status != 'error') {
          this.serviciosAsociado = response.details;
        }else{
          console.log(response.details)
        }   
        
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  consultarmvtoservicios(codmvto) {
    this._userService.httpGet('mvtoservicios/'+codmvto).subscribe(
      response => {
        this.mvtoservicios = response;
        if(!this.mobile){
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '80vh',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.mvtoservicios, modulo: 'mvtoservcomp', op: 1 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      },
      error => {
        console.log(<any>error);
      }
    )
  }

  consultarServiciosActivos() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year +'-'+ (monthIndex+1) +'-'+ day
    };
    this._userService.httpPost('serviciosActivos', data).subscribe(
      response => {
        if (response.status != 'error') {
          this.serviciosactivos = response.details;
        }else{
          console.log(response.details)
        } 
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

}
